import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/functions';

import config from './firebaseConfig';

const app = firebase.initializeApp(config);

// eslint-disable-next-line
if (location.hostname === 'localhost') {
  firebase.functions().useFunctionsEmulator('http://localhost:5001');
}

const auth = firebase.auth();

const firestore = firebase.firestore();
const rtdb = firebase.database();

const functions = firebase.functions();

export default app;

export {
  app,
  firebase,
  firestore,
  rtdb,
  auth,
  functions,
};
